const accreds = document.querySelectorAll( '.accreditations' );

const media = window.matchMedia( '(min-width: 769px)' );

accreds.forEach( setAccredSliderState );
media.addEventListener( 'change', () => {
    accreds.forEach( setAccredSliderState );
} );

function setAccredSliderState( accred ) {
    const numSlides = accred.dataset.slides;
    const slidesToShow = media.matches ? numSlides - 1 : 1;

    if ( media.matches && numSlides < 4 && accred.classList.contains( 'slick-initialized' ) ) {
        jQuery( accred ).slick( 'destroy' );
    } else if ( media.matches && accred.classList.contains( 'slick-initialized' ) ) {
        return;
    } else if ( media.matches && numSlides < 4 ) {
        return;
    } else {
        jQuery( accred ).slick( {
            infinite: true,
            arrows: false,
            slidesToShow,
            autoplay: true,
            variableWidth: true,
            centerMode: true,
            centerPadding: 0,
            swipeToSlide: true,
        } );
    }
}